// src/components/ui/Separator.js
export function Separator() {
    return <div className="border-t my-4" />;
  }
  